import { Component } from 'react';
import { makeBEM } from '../global/utils';
import { RevealAnimation, FormReveal } from './Animations';
import NoteForm from '../forms/NoteForm';
import { UTILITY_CSS_CLASSES } from '../global/constants';
import NoteController from '../controllers/NoteController';
import { GeneralObserver } from './Observer';

class NoteModule extends Component {
	constructor(props) {
		super(props);

		this.state = {
			controller: new NoteController(this.props.data),
			note: this.props.data,
			animate: this.props.animate,
			editMode: false,
			deleteAction: this.props.deleteAction ? this.props.deleteAction : false
		}

		this.moduleName = 'note';
		this.observer = false;
		this.bindFunctions();
	}

	// Binds functions to instance
	bindFunctions() {
		this.toggleEditMode = this.toggleEditMode.bind(this);
		this.reactFn = this.reactFn.bind(this);
	}

	componentDidMount() {
		this.initialSetup();
	}

	componentDidUpdate(prevProps) {
		if ( this.props.data !== prevProps.data ) {
			this.handlePropChange();
		}
	}

	handlePropChange() {
		const ctrl = this.state.controller;
		ctrl.setNote(this.props.data);
		this.setState(({
			controller: ctrl,
		}));
	}

	// Creates observer with rectFn 
	// Connects it to the controller
	initialSetup() {
		const ctrl = this.state.controller;
		this.observer = new GeneralObserver(this.reactFn);
		ctrl.addObserver(this.observer);

		this.setState({
			controller: ctrl
		})
	}

	// React fn for observer
	// Updates controller and note states
	reactFn() {
		const ctrl = this.state.controller;
		const note = ctrl.getNote();

		this.setState({
			controller: ctrl,
			note: note
		})
	}

	// Toggles editMode state
	toggleEditMode() {
        this.setState({
            editMode: !this.state.editMode
        })
    }

	// Renders a note object
	renderContent(note) {
		const className = `${this.moduleName} ${UTILITY_CSS_CLASSES.hasAction}`;
		return (
			<div 
				className={ className }
				onDoubleClick={this.toggleEditMode}
			>	
				<p className={ makeBEM(this.moduleName, 'body') }>
					{ note.getBody() }
				</p>
			</div>
		)
	}

	render () {
		const ctrl = this.state.controller;
		if ( !ctrl ) {
			return false;
		}

		const note = ctrl.getNote();
		const animate = this.state.animate;
		const editMode = this.state.editMode;
		const editModeClass = editMode ? UTILITY_CSS_CLASSES.editing : '';
		const wrapperClass = makeBEM(this.moduleName, 'wrapper');
		return(
			<div className={`${wrapperClass} ${editModeClass}`}>
				{
					animate ?
					<RevealAnimation key={note.id} direction='down' >
						{ this.renderContent(note) }
					</RevealAnimation>
					:
					this.renderContent(note)
				}
				{
					editMode &&
					<FormReveal>
						<NoteForm 
							className={makeBEM(this.moduleName, 'edit-form')}
							note={note.toFormObject()}
							discardForm={this.toggleEditMode}
							deleteSuccess={this.state.deleteAction}
							controller={ctrl}
						/>
					</FormReveal>
				}
			</div>
		);
	}
}

export default NoteModule;